<template>
  <v-container fluid>
    <div v-if="demande">
      <h2>Demande - produit publié concerné (si présent)</h2>
      <p>
        <v-icon>mdi-tag-text</v-icon>
        {{ demande.type }}
      </p>
      <p v-if="demande.idProduit > 0">
        <v-icon>mdi-medical-bag</v-icon>
        {{ demande.denominationCommercialeProduit }} (#{{ demande.idProduit }})

        <span v-if="demande.denominationCommune">
          - {{ demande.denominationCommune }}</span
        >
      </p>
    </div>
    <div v-if="demande == null">
      <v-container fluid>
        <v-row>
          <v-col cols="12" md="4" lg="3"> Type de demande: </v-col>
          <v-col>
            <v-autocomplete
              v-model="typeNvDemande"
              :items="typesDemandes"
              item-text="libelle"
              item-value="valeur"
              prepend-icon="mdi-tag-text"
              hide-details="auto"
              single-line
              filled
              dense
              :error-messages="typeNvDemandeErrors"
              @input="$v.typeNvDemande.$touch()"
              @blur="$v.typeNvDemande.$touch()"
            ></v-autocomplete>
          </v-col>
        </v-row>
        <v-row v-if="typeNvDemande">
          <v-col cols="12" md="4" lg="3">
            {{
              typeNvDemande == 1
                ? "Produit de base pour duplication"
                : "Produit concerné "
            }}:
          </v-col>
          <v-col>
            <v-autocomplete
              v-model="idProduitOriginal"
              :items="produitsFournisseur"
              :hint="typeNvDemande == 1 ? 'Optionnel' : null"
              item-text="denominationCommerciale"
              item-value="id"
              prepend-icon="mdi-medical-bag"
              hide-details="auto"
              single-line
              filled
              dense
              :error-messages="idProduitOriginalErrors"
              @input="$v.idProduitOriginal.$touch()"
              @blur="$v.idProduitOriginal.$touch()"
            ></v-autocomplete>
          </v-col>
        </v-row>
        <v-row v-if="typeNvDemande">
          <v-col cols="12" class="text-center">
            <v-btn
              :disabled="!nvDemandeValid"
              :loading="isCreating"
              depressed
              large
              color="produit"
              class="white--text"
              @click="initNvDemande"
            >
              <v-icon>mdi-plus-circle-outline</v-icon>
              <span>&nbsp; Compléter la demande</span>
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <div v-if="demande">
      <h2>Demande - Description et observations</h2>
      <v-textarea
        v-model="observations"
        :disabled="readOnly"
        auto-grow
        clearable
        dense
        filled
        hint="Merci d'indiquer ici ce sur quoi porte votre demande, le plus précisément et exhaustivement possible."
        :error-messages="observationsErrors"
        @input="$v.observations.$touch()"
        @blur="$v.observations.$touch()"
      ></v-textarea>
    </div>
    <produit-form v-if="produit" ref="produitComp"></produit-form>
    <v-container fluid v-if="demande && !readOnly">
      <v-btn
        :loading="savingOnly"
        :disabled="savingDisabled || false"
        color="primary"
        class="ma-2 white--text"
        @click="post"
      >
        <v-icon left dark> mdi-content-save </v-icon>
        Enregistrer
      </v-btn>
      <v-btn
        :loading="savingSending"
        :disabled="disabledButtons || user.estLimite"
        color="success"
        class="ma-2 white--text"
        @click="postSend"
      >
        <v-icon left dark> mdi-send-lock </v-icon>
        Enregistrer et transmettre
      </v-btn>
      <v-btn
        :loading="viewing"
        :disabled="disabledButtons || (demande && demande.typeNum == 4)"
        color="info"
        class="ma-2 white--text"
        @click="preview"
      >
        <v-icon left dark> mdi-file-find </v-icon>
        Aperçu
      </v-btn>
      <v-btn
        color="error"
        class="ma-2 white--text"
        :loading="closing"
        :disabled="closing || savingOnly || savingSending || viewing"
        @click="close"
      >
        <v-icon left dark> mdi-close-circle </v-icon>
        Quitter sans enregistrer
      </v-btn>
    </v-container>
    <v-container fluid v-if="readOnly">
      <v-btn
        color="primary"
        class="ma-2 white--text"
        :to="{ name: 'demandes' }"
      >
        <v-icon left dark> mdi-close-circle </v-icon>
        Revenir aux demandes
      </v-btn>
    </v-container>
  </v-container>
</template>

<script>
import ProduitForm from "@/components/ProduitDemandeForm.vue";
import { validationMixin } from "vuelidate";
import { required, requiredIf } from "vuelidate/lib/validators";
import FournisseurService from "@/services/FournisseurService";

export default {
  name: "DemandeMain",
  components: {
    ProduitForm,
  },
  mixins: [validationMixin],
  data() {
    return {
      typeNvDemande: null,
      idProduitOriginal: null,
      observations: null,
      type: null,
      idProduit: null,
      savingOnly: false,
      savingSending: false,
      viewing: false,
      closing: false,
      isCreating: false,
    };
  },
  computed: {
    user() {
      return this.$store.state.identite.fournisseur;
    },
    new() {
      return this.demande == null || this.demande.id == undefined;
    },
    readOnly() {
      // console.log(typeof this.demande.etat != "undefined");
      let result =
        this.demande != null &&
        typeof this.demande.etat != "undefined" &&
        (this.demande.etat == 2 || this.demande.etat == 4);
      // console.log("result", result);
      return result;
    },
    nvDemandeValid() {
      return (
        !this.$v.typeNvDemande.$invalid && !this.$v.idProduitOriginal.$invalid
      );
    },
    demande() {
      return this.$store.state.demandeEditee.demande;
    },
    produit() {
      return this.$store.state.demandeEditee.produit;
    },
    typesDemandes() {
      return this.$store.state.demandeEditee.typesDemandes;
    },
    produitsFournisseur() {
      return this.$store.state.demandeEditee.produitsFournisseur;
    },
    savingDisabled() {
      const pdt = this.produit;
      const refs = this.$refs;
      //this.$v.observations.required;
      //let pdtComp = this.$refs.produitComp;
      return (
        this.savingOnly ||
        this.savingSending ||
        this.viewing ||
        this.closing ||
        ((this.$v.observations.$invalid || !this.$v.observations.$invalid) &&
          pdt &&
          refs &&
          refs.produitComp &&
          (refs.produitComp.$v.denominationCommerciale.$invalid ||
            refs.produitComp.$v.idDenoCommune.$invalid))
      );
    },
    disabledButtons() {
      return (
        this.savingDisabled ||
        this.$v.observations.$invalid ||
        (this.produit &&
          this.$refs.produitComp &&
          this.$refs.produitComp.$v.$invalid)
      );
    },
    typeNvDemandeErrors() {
      const errors = [];
      if (!this.$v.typeNvDemande.$dirty || !this.new) return errors;
      !this.$v.typeNvDemande.required && errors.push("Obligatoire");
      return errors;
    },
    idProduitOriginalErrors() {
      const errors = [];
      if (!this.$v.idProduitOriginal.$dirty || !this.new) return errors;
      !this.$v.idProduitOriginal.required &&
        errors.push("Obligatoire pour le type de demande choisi");
      return errors;
    },
    observationsErrors() {
      const errors = [];
      if (!this.$v.observations.$dirty) return errors;
      !this.$v.observations.required && errors.push("Obligatoire");
      // !this.$v.denominationCommerciale.minLength &&
      //   errors.push("2 caractères au minimum");
      // !this.$v.denominationCommerciale.maxLength &&
      //   errors.push("500 caractères au maximum");
      return errors;
    },
  },
  methods: {
    initNvDemande() {
      if (this.isCreating) return;

      this.isCreating = true;

      let nvDemande = {
        typeNum: this.typeNvDemande,
        type: this.typesDemandes.find(
          (type) => type.valeur == this.typeNvDemande
        ).libelle,
      };
      if (this.idProduitOriginal) {
        nvDemande.idProduitOriginal = this.idProduitOriginal;
        // Obtention infos du produit
        FournisseurService.getProduitFournisseur(this.idProduitOriginal)
          .then((res) => {
            let produitFrn = res.data;
            Object.assign(nvDemande, {
              produitPublie: produitFrn.estPublie,
              denominationCommercialeProduit:
                produitFrn.denominationCommerciale,
              denominationCommune: produitFrn.denominationCommune,
            });
            this.$store.dispatch("demandeEditee/setDemandeEnCours", nvDemande);
            if (this.typeNvDemande < 4) {
              produitFrn.imagesReferences = [];
              produitFrn.imagesDescription = [];
              let removeImgIndexes = [];
              produitFrn.images.forEach((img, index) => {
                if (img.position == "references") {
                  produitFrn.imagesReferences.push(img);
                  removeImgIndexes.unshift(index);
                } else if (img.position == "description") {
                  produitFrn.imagesDescription.push(img);
                  removeImgIndexes.unshift(index);
                }
              });
              removeImgIndexes.forEach((index) => {
                produitFrn.images.splice(index, 1);
              });
              this.$store.dispatch(
                "demandeEditee/setProduitDemandeEnCours",
                produitFrn
              );
            }
          })
          .catch((err) => {
            if (
              err.response &&
              err.response.status &&
              err.response.status == 401
            ) {
              this.$store.dispatch(
                "setErreur",
                new Error("Vous avez été déconnecté.e")
              );
              this.$router.replace({ name: "home" });
            } else if (
              err.response &&
              err.response.status &&
              err.response.status == 404
            ) {
              this.$store.dispatch(
                "setErreur",
                new Error(
                  "Le produit n'a pas pu être obtenu du serveur d'Europharmat. Réssayer. Si l'erreur persiste, merci de contacter l'équipe d'Europharmat."
                )
              );
            } else {
              this.$store.dispatch("setErreur", err);
            }
          })
          .finally(() => {
            this.isCreating = false;
          });
      } else if (this.typeNvDemande == 1) {
        let produitFrn = {
          idFournisseur: this.$store.state.identite.fournisseur.id,
        };
        produitFrn.references = [];
        produitFrn.domaines = [];
        produitFrn.images = [];
        produitFrn.images = [];
        produitFrn.imagesReferences = [];
        produitFrn.imagesDescription = [];
        produitFrn.documents = [];
        produitFrn.substances = [];
        produitFrn.elements = [];
        produitFrn.sterilisations = [];
        this.$store.dispatch(
          "demandeEditee/setProduitDemandeEnCours",
          produitFrn
        );
        this.$store.dispatch("demandeEditee/setDemandeEnCours", nvDemande);
        this.isCreating = false;
      }
    },
    makeDemand() {
      let demande = JSON.parse(JSON.stringify(this.demande)); //Object.assign({}, this.demande);
      demande.type = demande.typeNum;
      delete demande.typeNum;
      demande.observations = this.observations;
      if (demande.type != 4) {
        //ajout du produit si demande autre que suppression
        demande.produitDemande = JSON.parse(JSON.stringify(this.produit));
        // remplacement des propriétés éditées par les valeurs des contrôles du formulaire
        demande.produitDemande.divisionFournisseur =
          this.$refs.produitComp.divisionFournisseur;
        demande.produitDemande.idDenoCommune =
          this.$refs.produitComp.idDenoCommune;
        demande.produitDemande.denominationCommerciale =
          this.$refs.produitComp.denominationCommerciale;
        demande.produitDemande.codeProduit = this.$refs.produitComp.codeProduit;
        demande.produitDemande.cladimedPro = this.$refs.produitComp.cladimedPro;
        demande.produitDemande.codeLpp = this.$refs.produitComp.codeLpp;
        demande.produitDemande.classeDm = this.$refs.produitComp.classeDm;
        demande.produitDemande.marquageCeB = this.$refs.produitComp.marquageCeB;
        demande.produitDemande.marquageCe = this.$refs.produitComp.marquageCe;
        demande.produitDemande.organismeCe = this.$refs.produitComp.organismeCe;
        demande.produitDemande.dateCommercialisation =
          this.$refs.produitComp.dateCommercialisation;
        demande.produitDemande.fabricant = this.$refs.produitComp.fabricant;
        demande.produitDemande.statutFournisseur =
          this.$refs.produitComp.statutFournisseur;
        demande.produitDemande.descriptif = this.$refs.produitComp.descriptif;
        demande.produitDemande.avecLatex = this.$refs.produitComp.avecLatex;
        demande.produitDemande.avecPhtalates =
          this.$refs.produitComp.avecPhtalates;
        demande.produitDemande.origineAnimaleOuBiologique =
          this.$refs.produitComp.origineAnimaleOuBiologique;
        demande.produitDemande.pertubateursEndocriniens =
          this.$refs.produitComp.pertubateursEndocriniens;
        demande.produitDemande.substancesCancerogenes =
          this.$refs.produitComp.substancesCancerogenes;
        demande.produitDemande.irmCompatibilite =
          this.$refs.produitComp.irmCompatibilite;
        demande.produitDemande.autresComposants =
          this.$refs.produitComp.autresComposants;
        demande.produitDemande.dispositifEtAccessoiresAssocies =
          this.$refs.produitComp.dispositifEtAccessoiresAssocies;
        demande.produitDemande.indicationsNotice =
          this.$refs.produitComp.indicationsNotice;
        demande.produitDemande.indicationsTexte =
          this.$refs.produitComp.indicationsTexte;
        demande.produitDemande.sterile = this.$refs.produitComp.sterile;
        demande.produitDemande.usageUnique = this.$refs.produitComp.usageUnique;
        demande.produitDemande.conditionsConservation =
          this.$refs.produitComp.conditionsConservation;
        demande.produitDemande.precautions = this.$refs.produitComp.precautions;

        // Gestion enregistrement sans transmission (des champs trop longs pourraient être transmis)
        // Descriptif
        if (demande.produitDemande.descriptif) {
          demande.produitDemande.descriptif =
            demande.produitDemande.descriptif.substring(0, 5000);
        } else {
          demande.produitDemande.descriptif = "";
        }

        // Deno commerciale
        if (demande.produitDemande.denominationCommerciale) {
          demande.produitDemande.denominationCommerciale =
            demande.produitDemande.denominationCommerciale.substring(0, 500);
        } else {
          demande.produitDemande.denominationCommerciale = "";
        }

        // Deno commerciale
        // if (demande.produitDemande.denominationCommerciale) {
        //   demande.produitDemande.denominationCommerciale =
        //     demande.produitDemande.denominationCommerciale.substring(0, 500);
        // } else {
        //   demande.produitDemande.denominationCommerciale = "";
        // }

        // Fabricant
        if (demande.produitDemande.fabricant) {
          demande.produitDemande.fabricant =
            demande.produitDemande.fabricant.substring(0, 50);
        } else {
          demande.produitDemande.fabricant = "";
        }

        // Marquage CE
        if (demande.produitDemande.marquageCe) {
          demande.produitDemande.marquageCe =
            demande.produitDemande.marquageCe.substring(0, 120);
        } else {
          demande.produitDemande.marquageCe = "";
        }

        // Code produit
        if (demande.produitDemande.codeProduit) {
          demande.produitDemande.codeProduit =
            demande.produitDemande.codeProduit.substring(0, 50);
        } else {
          demande.produitDemande.codeProduit = "";
        }

        // Classe DM
        if (demande.produitDemande.classeDm) {
          demande.produitDemande.classeDm =
            demande.produitDemande.classeDm.substring(0, 20);
        } else {
          demande.produitDemande.classeDm = "";
        }

        // Code LPP
        if (demande.produitDemande.codeLpp) {
          demande.produitDemande.codeLpp =
            demande.produitDemande.codeLpp.substring(0, 80);
        } else {
          demande.produitDemande.codeLpp = "";
        }

        // Numéro organisme notifié
        if (demande.produitDemande.organismeCe) {
          demande.produitDemande.organismeCe =
            demande.produitDemande.organismeCe.substring(0, 80);
        } else {
          demande.produitDemande.organismeCe = "";
        }

        // Cladimed
        if (demande.produitDemande.cladimedPro) {
          demande.produitDemande.cladimedPro =
            demande.produitDemande.cladimedPro.substring(0, 50);
        } else {
          demande.produitDemande.cladimedPro = "";
        }

        // Division Fournisseur
        if (demande.produitDemande.divisionFournisseur) {
          demande.produitDemande.divisionFournisseur =
            demande.produitDemande.divisionFournisseur.substring(0, 80);
        } else {
          demande.produitDemande.divisionFournisseur = "";
        }

        // ID Deno COmmune
        // if (demande.produitDemande.idDenoCommune == null) {
        //   demande.produitDemande.idDenoCommune = 0;
        // }

        //Gestion collections d'ids
        let idCollections = ["sterilisations", "substances"];
        idCollections.forEach((colName) => {
          let idColName =
            "id" + colName.charAt(0).toUpperCase() + colName.substring(1);
          demande.produitDemande[idColName] = [];
          demande.produitDemande[colName].forEach((item) => {
            demande.produitDemande[idColName].push(item.id);
          });
        });
        // Reste images des autres collections
        demande.produitDemande.imagesReferences.forEach((img) => {
          img.position = "references";
          demande.produitDemande.images.push(img);
        });
        delete demande.produitDemande.imagesReferences;
        demande.produitDemande.imagesDescription.forEach((img) => {
          img.position = "description";
          demande.produitDemande.images.push(img);
        });
        delete demande.produitDemande.imagesDescription;
      }

      if (demande.type == 1) {
        demande.idProduitOriginal = demande.idProduit;
      } else {
        demande.idProduitOriginal = demande.idProduit || this.idProduitOriginal;
      }

      delete demande.idProduit;

      //console.log(demande);

      // le payload doit être un form-data
      const payload = new FormData();
      payload.append("jsonData", JSON.stringify(demande));

      // ajout payload images et documents
      if (demande.produitDemande) {
        this.produit.images.forEach((img) => {
          if (img.fileCtl) {
            //console.log(img.fileCtl);
            // transmission de l'image
            payload.append("images", img.fileCtl);
          }
        });
        this.produit.imagesReferences.forEach((img) => {
          if (img.fileCtl) {
            //console.log(img.fileCtl);
            // transmission de l'image
            payload.append("images", img.fileCtl);
          }
        });
        this.produit.imagesDescription.forEach((img) => {
          if (img.fileCtl) {
            //console.log(img.fileCtl);
            // transmission de l'image
            payload.append("images", img.fileCtl);
          }
        });

        this.produit.documents.forEach((doc) => {
          //console.log("DemandeMain doc", doc);

          if (doc.fileCtl) {
            //console.log("DemandeMain doc.fileCtl", doc.fileCtl);
            // transmission de l'image
            payload.append("documents", doc.fileCtl);
          }
        });
      }

      let methodProm = null;
      if (this.new) {
        methodProm = FournisseurService.addDemande(payload);
      } else {
        methodProm = FournisseurService.updateDemande(this.demande.id, payload);
      }
      return methodProm;
    },
    post() {
      // Enregistrer: envoyer produit au service, sans changer l'état de la demande
      this.savingOnly = true;
      let saveMethod = this.makeDemand();
      saveMethod
        .then(() => {
          this.$store.dispatch("demandeEditee/setDemandeEnCours", null);
          this.$store.dispatch("demandeEditee/setProduitDemandeEnCours", null);
          this.$router.push({ name: "demandes" });
        })
        .catch((err) => {
          if (
            err.response &&
            err.response.status &&
            err.response.status == 401
          ) {
            this.$store.dispatch(
              "setErreur",
              new Error("Vous avez été déconnecté.e")
            );
            this.$router.replace({ name: "home" });
          } else {
            this.$store.dispatch(
              "setErreur",
              // new Error(
              //   "L'enregistrement de la demande sur le serveur a échoué. Veuillez réessayer. Dans l'hypothèse où cette erreur se reproduirait, merci de contacter l'équipe d'Europharmat."
              // )
              err
            );
          }
        })
        .finally(() => {
          this.savingOnly = false;
          this.savingSending = false;
        });
    },
    postSend() {
      // Enregistrer et transmettre: envoyer produit au service, et changer l'état de la demande
      this.savingSending = true;
      let saveMethod = this.makeDemand();
      saveMethod
        .then((res) => {
          let id = this.demande.id;
          let demRetournee = res.data;
          if (demRetournee != null && demRetournee.id) {
            id = demRetournee.id;
          }

          FournisseurService.sendDemandeToPharmat(id)
            .then(() => {
              this.$store.dispatch("demandeEditee/setDemandeEnCours", null);
              this.$store.dispatch(
                "demandeEditee/setProduitDemandeEnCours",
                null
              );
              this.$router.push({ name: "demandes" });
            })
            .catch((err) => {
              if (
                err.response &&
                err.response.status &&
                err.response.status == 401
              ) {
                this.$store.dispatch(
                  "setErreur",
                  new Error("Vous avez été déconnecté.e")
                );
                this.$router.replace({ name: "home" });
              } else {
                this.$store.dispatch(
                  "setErreur",
                  new Error(
                    "L'envoi automatique du mail à Europharmat a échoué. Merci de contacter l'équipe d'Europharmat afin de l'informer du dépôt de votre demande."
                  )
                );
              }
            })
            .finally(() => {
              this.savingSending = false;
            });
        })
        .catch((err) => {
          if (
            err.response &&
            err.response.status &&
            err.response.status == 401
          ) {
            this.$store.dispatch(
              "setErreur",
              new Error("Vous avez été déconnecté.e")
            );
            this.$router.replace({ name: "home" });
          } else {
            this.$store.dispatch(
              "setErreur",
              new Error(
                "L'enregistrement de la demande sur le serveur a échoué. Veuillez réessayer. Dans l'hypothèse où cette erreur se reproduirait, merci de contacter l'équipe d'Europharmat."
              )
            );
          }
        })
        .finally(() => {
          this.savingSending = false;
        });
    },
    preview() {
      this.viewing = true;
      // let saveMethod = this.makeDemand();
      // saveMethod.then(() => {
      this.$router.push({ name: "apercu" });
      // });
      this.viewing = false;
    },
    close() {
      // Fermer sans enregistrer
      this.closing = true;
      this.$router.push({ name: "demandes" });
    },
    createDemandeFromForm() {
      let demande = {
        type: this.type || this.demande.typeNum,
        idProduitOriginal: this.idProduit || this.demande.idProduit,
        observations: this.observations,
      };
      let produit = {};
      demande.produitDemande = produit;
      return demande;
    },
  },
  mounted() {
    if (this.demande) {
      //this.observations = this.demande.observations;
      for (let prop in this.demande) {
        try {
          this[prop] = this.demande[prop];
        } catch (ex) {
          console.log(ex);
        }
      }
      this.$v.$touch();
    }
  },
  validations: {
    observations: {
      required,
    },
    typeNvDemande: {
      required,
    },
    idProduitOriginal: {
      required: requiredIf((nm) => {
        return nm.typeNvDemande != 1;
      }),
    },
    // type: {
    //   required: requiredIf(() => this.new),
    // },
    // idProduit: {
    //   required: requiredIf(
    //     () => this.new && (this.type == 2 || this.type == 3)
    //   ),
    // },
  },
};
</script>

<style>
h3 {
  margin-top: 1.5em;
}
</style>
